import { getPeriodTranslation } from './chunk-TIEJ62BC.mjs';
import { EReportPeriod, EReportFileType, EReportRepeatType, ESalesOverviewReportTemplate } from './chunk-ER3UI63V.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';

// src/helpers/factories/reports/dropdownFactories.ts
var getFileTypeTranslation = (fileType) => i18n_config_default.t(`reports.fields.fileTypeOptions.${fileType}`);
var getRepeatTypeTranslation = (repeatType) => i18n_config_default.t(`reports.fields.repeatTypeOptions.${repeatType}`);
var getSalesOverviewTemplateTranslation = (template) => i18n_config_default.t(`reports.fields.templateOptions.${template}`);
function createDropdownHelpers(enumType, getTranslation, indexStart = 1) {
  return Object.values(enumType).reduce(
    (acc, value) => {
      acc.valueToEnum[acc.index] = value;
      acc.enumToValue[value] = acc.index;
      acc.dropdownOptions.push({
        label: getTranslation(value),
        value: acc.index
      });
      acc.index++;
      return acc;
    },
    {
      index: indexStart,
      valueToEnum: {},
      enumToValue: {},
      dropdownOptions: []
    }
  );
}
var {
  valueToEnum: periodValueToPeriod,
  enumToValue: periodToPeriodValue,
  dropdownOptions: periodDropdownOptions
} = createDropdownHelpers(EReportPeriod, getPeriodTranslation);
var {
  valueToEnum: fileTypeValueToFileType,
  enumToValue: fileTypeToFileTypeValue,
  dropdownOptions: fileTypeDropdownOptions
} = createDropdownHelpers(EReportFileType, getFileTypeTranslation);
var {
  valueToEnum: repeatTypeValueToRepeatType,
  enumToValue: repeatTypeToRepeatTypeValue,
  dropdownOptions: repeatTypeDropdownOptions
} = createDropdownHelpers(EReportRepeatType, getRepeatTypeTranslation);
var {
  valueToEnum: salesOverviewTemplateValueToTemplate,
  enumToValue: salesOverviewTemplateToTemplateValue,
  dropdownOptions: salesOverviewTemplateDropdownOptions
} = createDropdownHelpers(
  ESalesOverviewReportTemplate,
  getSalesOverviewTemplateTranslation
);

export { createDropdownHelpers, fileTypeDropdownOptions, fileTypeToFileTypeValue, fileTypeValueToFileType, getFileTypeTranslation, getRepeatTypeTranslation, getSalesOverviewTemplateTranslation, periodDropdownOptions, periodToPeriodValue, periodValueToPeriod, repeatTypeDropdownOptions, repeatTypeToRepeatTypeValue, repeatTypeValueToRepeatType, salesOverviewTemplateDropdownOptions, salesOverviewTemplateToTemplateValue, salesOverviewTemplateValueToTemplate };
